export default __webpack_public_path__ + "static/media/event.ee4c93e6.png";